import { Loading } from '@library/components/Loading';
import { PageTitle } from '@library/components/PageTitle';
import { Simulations } from '@bo-components/simulations/Simulations';
import { useGame } from '@bo-hooks/useGame';
import { useParams } from 'react-router-dom';

export const SimulationList = () => {
  const { gameId, leagueId } = useParams<{
    gameId: string;
    leagueId: string;
  }>();

  const { game, /* isLeagueGameError, */ isLeagueGameLoading } = useGame({
    gameId,
    leagueId
  });

  const gameTitle = `${game?.away_team_name ?? ''} vs. ${
    game?.home_team_name ?? ''
  }`;

  if (isLeagueGameLoading) {
    return <Loading loadingMessage="Loading Game" />;
  }

  return (
    <div className="flex w-auto flex-col gap-4 px-6 pb-2 pt-3">
      <div className="flex justify-between">
        <PageTitle title={`Existing Simulations For ${gameTitle}`} />
      </div>

      <Simulations gameId={gameId} leagueId={leagueId} />
    </div>
  );
};
